export default __webpack_public_path__ + "static/media/cert-finance-HKIRC.567cdb8d.jpg";